"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIAlert = _interopRequireDefault(require("UIComponents/alert/UIAlert"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIContactSalesButton = _interopRequireDefault(require("ui-addon-upgrades/button/UIContactSalesButton"));

var PurchaseMotionTypes = _interopRequireWildcard(require("ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes"));

var _MerchandiseIds = require("self-service-api/constants/MerchandiseIds");

var PurchaseMotionsLocations = _interopRequireWildcard(require("pricing-pages-unified-ui/constants/PurchaseMotionsLocations"));

var _GatingSelectors = require("../../selectors/GatingSelectors");

var _ProductOwnershipSelectors = require("../../selectors/ProductOwnershipSelectors");

var _ProductsAndPlansNavIds = _interopRequireDefault(require("../../constants/ProductsAndPlansNavIds"));

var _PurchaseMotionSelectors = require("../../selectors/PurchaseMotionSelectors");

var PARCELS_TO_CHECK = ['marketing-partner-basic-2011', 'marketing-partner-basic-legacy', 'marketing-basic'];

var BasicPromoBanner = function BasicPromoBanner(_ref) {
  var promoKey = _ref.promoKey,
      contactIsc = _ref.contactIsc;
  return _react.default.createElement(_UIAlert.default, {
    titleText: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.promotions.marketingBasicPromoBanner." + promoKey + ".title"
    }),
    type: "info"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.promotions.marketingBasicPromoBanner." + promoKey + ".body"
  }), _react.default.createElement(_UILink.default, {
    className: "m-left-2",
    external: true,
    href: "https://legal.hubspot.com/marketing-basic-upgrade-terms"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.promotions.marketingBasicPromoBanner.promotionDetails"
  })), _react.default.createElement(_UIContactSalesButton.default, {
    contactIsc: contactIsc,
    className: "m-left-4",
    size: "small",
    use: "tertiary",
    upgradeData: {
      app: 'pricing-pages',
      screen: 'marketing',
      upgradeProduct: 'marketing-pro',
      uniqueId: "basic-promo-" + promoKey
    }
  }));
};

var MarketingBasicPromoBanner = function MarketingBasicPromoBanner(_ref2) {
  var hasMarketingBasic = _ref2.hasMarketingBasic,
      hub = _ref2.hub,
      isUngatedForSamePrice = _ref2.isUngatedForSamePrice,
      isUngatedForHalfOff = _ref2.isUngatedForHalfOff,
      purchaseMotions = _ref2.purchaseMotions;
  if (hub !== _ProductsAndPlansNavIds.default.MARKETING) return null;
  if (!hasMarketingBasic) return null;
  var contactIsc = purchaseMotions.includes(PurchaseMotionTypes.TALK_TO_SALES_FALLBACK);
  return _react.default.createElement(_react.Fragment, null, isUngatedForHalfOff && _react.default.createElement(BasicPromoBanner, {
    contactIsc: contactIsc,
    promoKey: "halfOff"
  }), isUngatedForSamePrice && _react.default.createElement(BasicPromoBanner, {
    contactIsc: contactIsc,
    promoKey: "samePrice"
  }));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    hasMarketingBasic: (0, _ProductOwnershipSelectors.hasParcelSelector)(state, PARCELS_TO_CHECK),
    isUngatedForHalfOff: (0, _GatingSelectors.isUngatedSelector)(state, 'Growth:MarketingBasicPromoHalfOff'),
    isUngatedForSamePrice: (0, _GatingSelectors.isUngatedSelector)(state, 'Growth:MarketingBasicPromoSamePrice'),
    purchaseMotions: (0, _PurchaseMotionSelectors.purchaseMotionsSelector)(state, PurchaseMotionsLocations.MERCH_CARD, _MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(MarketingBasicPromoBanner);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/banners/MarketingBasicPromoBanner.js
// module id = 792
// module chunks = 5 6